import { Injectable } from '@angular/core';
import { UsuarioService } from './usuario-service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { timeout } from 'rxjs/operators/timeout';
import { map } from 'rxjs/operators/map';
import { catchError } from 'rxjs/operators/catchError';
import { Observable, throwError } from 'rxjs';

@Injectable()
export class UtilService {
  headers: any;
  options: any;
  timeoutMiliSeconds: any = 3600000;
  usuarioLogado: any;

  //AO FAZER O DEPLOY ALTERAR O enviroments.ts
  //app Base 
  public appBase = "agora-api/ws/";

  //LOCAL => localhost
  //public protocolo = "http";
  //public host = "localhost";
  //public porta = "8080";
  
  //HOMOLOGACAO => 172.26.18.54
 // public protocolo = "https";
 // public host = "agora-hom.tce.ce.gov.br";
 // public porta = "10443";

  // PRODUCAO => 
     public protocolo = "https";
     public host = "agora-api.tce.ce.gov.br";
     public porta = "9443";

  public urlBase = this.protocolo + ":" + "//" + this.host + ":" + this.porta + "/" + this.appBase;

  constructor(
    public http: HttpClient,
    private usuarioService: UsuarioService) {
    this.usuarioLogado = usuarioService.obtemUsuario();
    console.log('UtilService.constructor', this.usuarioLogado);
    this.headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    this.options = { headers: this.headers };
  }

  public getOptions() {
    let usuarioLogado = this.usuarioService.obtemUsuario();
    let headers: HttpHeaders;

    if (usuarioLogado != null && usuarioLogado.token != "") {
      headers = new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer=' + usuarioLogado.token
        });
    }
    else {
      headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    }

    return { headers: headers };
  }

  public getOptionsExterno() {

    let headers: HttpHeaders;
    headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return { headers: headers };
  }

  public setTokenMultiparFormData(token) {
    this.headers = new HttpHeaders(
      {
        'Accept-Encoding': 'multipart/form-data',
        'Authorization': 'Bearer=' + token
      }
    );
  }

  public setToken(token) {
    this.headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer=' + token
      }
    );
  }

  private handleError(error: any) {    
    if (error.error) {
      let errMsg =
        error.error.mensagem ? { mensagem : error.error.mensagem } :
          error.error.listaErros ? { inconsistencias : error.error.listaErros } :
            error.name == "TimeoutError" || error.url == null ? { mensagem : "Não foi possível acessar o servidor." } :
              error.status ? { mensagem : JSON.parse(error._body) } :
                (error.message) ? { mensagem : error.message } :
                  { mensagem : "Erro desconhecido." };

      return throwError(errMsg);
    }
  }

  private handleSucess(sucess: any) {
    return sucess;
  }

  public getJSON(urlObtencaoDados: string): Observable<any> {
    let options = this.getOptions();
    return this.http.get(this.urlBase + urlObtencaoDados, options)
      .pipe(timeout(this.timeoutMiliSeconds), map(res => res), catchError(error => this.handleError(error)));
  }

  public getJSONExterno(fullURL: string): Observable<any> {
    let options = this.getOptionsExterno();
    return this.http.get(fullURL, options)
      .pipe(timeout(this.timeoutMiliSeconds), map(res => res), catchError(error => this.handleError(error)));
  }

  public deleteJSON(urlObtencaoDados: string): Observable<any> {
    let options = this.getOptions();
    return this.http.delete(this.urlBase + urlObtencaoDados, options)
      .pipe(timeout(this.timeoutMiliSeconds), map(res => res), catchError(error => this.handleError(error)));
  }

  public postJSON(urlObtencaoDados: string, parametros: string): Observable<any> {
    let options = this.getOptions();
    return this.http.post(this.urlBase + urlObtencaoDados, parametros, options)
      .pipe(timeout(this.timeoutMiliSeconds), catchError(error => this.handleError(error)));
  }

  public putJSON(urlObtencaoDados: string, parametros: string): Observable<any> {
    let options = this.getOptions();
    return this.http.put(this.urlBase + urlObtencaoDados, parametros, options)
      .pipe(timeout(this.timeoutMiliSeconds), map(res => res), catchError(error => this.handleError(error)));
  }

  public postArquivo(urlObtencaoDados: string, formData: any): Observable<any> {
    let usuarioTemp = this.usuarioService.obtemUsuario();
    this.setTokenMultiparFormData(usuarioTemp.token);
    let options = { headers: this.headers };
    return this.http.post(this.urlBase + urlObtencaoDados, formData, options)
      .pipe(timeout(this.timeoutMiliSeconds), map(res => res), catchError(error => this.handleError(error)));
  }
}



// WEBPACK FOOTER //
// ./src/providers/util-service.ts